
export default function Unauthorized() {
    return (
        <div className="unauthorized"><h1>You are not authorized to open this page.</h1></div>
    );
};